import React from 'react';
import PropTypes from 'prop-types';

import Table from '@appComponents/Table';
import {Columns} from '@modules/product/components/Table/Columns';
import {RowRenderer} from '@modules/product/components/Table/RowRenderer';

const ProductTable = ({products = [], loading = true}) => {
    return (
        <div className='products__table'>
            <Table
                name='productsList'
                columns={Columns}
                data={products}
                loading={loading}
                noDataText='No products found'
                rowRenderer={RowRenderer}
                pagination={false}
            />
        </div>
    );
};

ProductTable.propTypes = {
    products: PropTypes.array,
    loading: PropTypes.bool,
};

export default ProductTable;
